/*
 * @Author: Chao Yang
 * @Date: 2020-07-22 03:25:24
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-07-25 03:15:08
 */

import { BaseProxy } from '../base.proxy';
import { IPackMenu } from '../../model/common/iPackMenu.model';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class CommonProxy extends BaseProxy {
  getUserPacks() {
    if (environment.feature.newApi === false) {
      return this._http.get<IPackMenu[]>('/ip/api/pack', {}).pipe(
        map((response) => {
          if (typeof response === 'string') {
            return [];
          } else {
            return response;
          }
        })
      );
    } else {
      return this._http.get<IPackMenu[]>('/ip-api/api/pack', {}).pipe(
        map((response) => {
          if (typeof response === 'string') {
            return [];
          } else {
            return response;
          }
        })
      );
    }
  }

  saveUserPack(code: string) {
    if (environment.feature.newApi === false) {
      return this._http.post('/api2/Common/SaveUserPack', { PackCode: code });
    } else {
      return this._http.post('/ip-api/api/pack?packCode=' + code, undefined);
    }
  }
}
